import axios from "axios";
import http from "./http-common";

const getClientIP = async () => {
	try {
		const response = await fetch("https://api.ipify.org?format=json");
		if (response.status === 401) {
			localStorage.removeItem('esignature');
			window.location.href = '/';
			return "unknown";
		}
		const data = await response.json();
		console.log('data',data);
		return data.ip;
	} catch (error) {
		console.error("Error getting client IP:", error);
		return "unknown";
	}
};

export const getDocFormsToAssign = async () => {
	const response = await http.get(
		`${process.env.REACT_APP_HOST_API_FORMS}/forms/api/v1/documents?status=pending`,
		{
			headers: {
				"Content-Type": "application/json",
				Authorization:
					"Bearer " + JSON.parse(localStorage.getItem("esignature") || '{"token":""}').token,
				customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
				userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
			},
		}
	);
	return response.data;
};

export const getDocFormsComlpleted = async () => {
	const response = await http.get(
		`${process.env.REACT_APP_HOST_API_FORMS}/forms/api/v1/documents?status=completed`,
		{
			headers: {
				"Content-Type": "application/json",
				Authorization:	
					"Bearer " + JSON.parse(localStorage.getItem("esignature") || '{"token":""}').token,
				customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
				userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
			},
		}
	);
	return response.data;
};

export const getDocFormFiller = async (id, form_request_id) => {
	const email = JSON.parse(localStorage.getItem("esignature") || '{"email":""}').email;
	const response = await http.get(`${process.env.REACT_APP_HOST_API_FORMS}/forms/api/v1/templates/${id}/json?assignee=${email}&form_request_id=${form_request_id}`, {
			headers: {
				"Content-Type": "application/json",
				Authorization:
					"Bearer " + JSON.parse(localStorage.getItem("esignature") || '{"token":""}').token,
				customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
				userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
			},
	});
	return response.data;
};

export const fillDocForm = async (id, values) => {
	const response = await http.post(`${process.env.REACT_APP_HOST_API_FORMS}/forms/api/v1/fill`, {
		formRequestId: id,
		fields: values,
		ip: await getClientIP(),
	}, {
		headers: {
			"Content-Type": "application/json",
			Authorization:
				"Bearer " + JSON.parse(localStorage.getItem("esignature") || '{"token":""}').token,
		},
	});
	return response.data;
};

export const getSignatureListByUser = async () => {
	const response = await http.get(`${process.env.REACT_APP_HOST_API_FORMS}/forms/api/v1/users/signature`, {
		headers: {
			"Content-Type": "application/json",
			Authorization:
				"Bearer " + JSON.parse(localStorage.getItem("esignature") || '{"token":""}').token,
			customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
			userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
		},
	});
	return response.data;
};

export const updateSignature = async (signature) => {
	const data = {
		"imageFormat": "png",
		signatureBase64: signature,
	}
	const response = await http.put(`${process.env.REACT_APP_HOST_API_FORMS}/forms/api/v1/users/signature`, data, {
		headers: {
			"Content-Type": "application/json",
			Authorization:
			"Bearer " + JSON.parse(localStorage.getItem("esignature") || '{"token":""}').token,
			customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
			userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
		},
	});
	return response.data;
};